(() => {
  if (window.__lorenzosCartDrawerDirectControllerReady) return;
  window.__lorenzosCartDrawerDirectControllerReady = true;

  const bodyClass = document.body ? document.body.className : '';
  const directControlsDisabled = /\btemplate-(article|blog)\b/.test(bodyClass);
  const directAddSelector = '.lorenzos-collection-card__form, .lg-category-funnel__quick-add';

  const getDrawer = () => document.getElementById('CartDrawer');
  let lastHandledCartControl = 0;

  const getActiveCountry = () => {
    const shopifyCountry = window.Shopify && typeof window.Shopify.country === 'string'
      ? window.Shopify.country.toUpperCase()
      : '';

    if (shopifyCountry) return shopifyCountry;

    const countryField = document.querySelector(
      'select[name="country_code"], input[name="country_code"]:checked, input[name="country_code"][type="hidden"]'
    );

    if (countryField && countryField.value) return String(countryField.value).toUpperCase();

    return 'DE';
  };

  const shippingThreshold = () => getActiveCountry() === 'AT' ? 13000 : 7900;

  const formatMoney = (cents) => {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
    }
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  };

  const ensureEnhancementStyles = () => {
    if (document.getElementById('LorenzosCartCountryAndLineTotalStyles')) return;

    const style = document.createElement('style');
    style.id = 'LorenzosCartCountryAndLineTotalStyles';
    style.textContent = `
      #CartDrawer .lorenzos-cart-line-total {
        display: grid;
        gap: 1px;
        justify-items: end;
        margin-top: 4px;
      }
      #CartDrawer .lorenzos-cart-line-total small {
        color: #81786e;
        font-size: 10.5px;
        line-height: 1.2;
      }
      #CartDrawer .lorenzos-cart-line-total strong {
        color: #17130f;
        font-size: 12px;
        font-weight: 900;
        line-height: 1.25;
      }
    `;
    document.head.appendChild(style);
  };

  const updateShippingLegalNote = () => {
    const drawer = getDrawer();
    if (!drawer) return;

    const note = drawer.querySelector('.lorenzos-cart-drawer__shipping-note small');
    if (!note) return;

    const country = getActiveCountry();
    const thresholdLabel = country === 'AT' ? '130 €' : '79 €';
    const destinationLabel = country === 'AT' ? ' nach Österreich' : '';
    const html = 'Inkl. MwSt. zzgl. <a href="https://lorenzos-gusto.com/policies/shipping-policy">Versandkosten</a> ab 5,90 € je nach Versanddienstleister – ab ' + thresholdLabel + ' versandkostenfrei' + destinationLabel + '. Gutscheincodes kannst du im Checkout eingeben.';

    if (note.innerHTML !== html) note.innerHTML = html;
  };

  const updateLineTotals = (cart) => {
    const drawer = getDrawer();
    if (!drawer || !cart || !Array.isArray(cart.items)) return;

    const itemsByKey = {};
    cart.items.forEach((item) => {
      itemsByKey[item.key] = item;
    });

    drawer.querySelectorAll('[data-products] .cart__item[data-key]').forEach((row) => {
      const item = itemsByKey[row.getAttribute('data-key')];
      const priceColumn = row.querySelector('.cart__item-price-col');
      let lineTotal = row.querySelector('.lorenzos-cart-line-total');

      if (!item || !priceColumn || item.quantity <= 1) {
        if (lineTotal) lineTotal.remove();
        return;
      }

      if (!lineTotal) {
        lineTotal = document.createElement('div');
        lineTotal.className = 'lorenzos-cart-line-total';
        priceColumn.appendChild(lineTotal);
      }

      lineTotal.setAttribute('aria-label', 'Gesamtpreis für ' + item.quantity + ' Stück');
      lineTotal.innerHTML = '<small>' + item.quantity + ' × ' + formatMoney(item.final_price) + '</small>' +
        '<strong>Gesamt ' + formatMoney(item.final_line_price) + '</strong>';
    });
  };

  const setDrawerEmptyState = (cart) => {
    const drawer = getDrawer();
    if (!drawer || !cart) return;

    const isEmpty = Number(cart.item_count) <= 0;
    drawer.classList.toggle('is-empty', isEmpty);

    const form = drawer.querySelector('#CartDrawerForm');
    if (form && form.parentNode && form.parentNode !== drawer) {
      form.parentNode.classList.toggle('is-empty', isEmpty);
    }
  };

  const updateSummary = (cart) => {
    const drawer = getDrawer();
    if (!drawer || !cart) return;

    ensureEnhancementStyles();
    setDrawerEmptyState(cart);

    const subtotal = drawer.querySelector('[data-subtotal]');
    if (subtotal) subtotal.innerHTML = formatMoney(cart.total_price);

    const threshold = shippingThreshold();
    drawer.setAttribute('data-lorenzos-cart-threshold', String(threshold));
    drawer.setAttribute('data-lorenzos-cart-country', getActiveCountry());

    const text = drawer.querySelector('[data-lorenzos-drawer-shipping-text]');
    const bar = drawer.querySelector('[data-lorenzos-drawer-shipping-bar]');

    if (text && bar) {
      const remaining = threshold - cart.total_price;
      const progress = Math.max(0, Math.min(100, Math.round((cart.total_price / threshold) * 100)));
      text.innerHTML = remaining > 0 ? 'Noch <strong>' + formatMoney(remaining) + '</strong> bis zum kostenlosen Versand.' : '<strong>Perfetto!</strong> Dein Paket qualifiziert sich f&uuml;r kostenlosen Versand.';
      bar.style.width = progress + '%';
    }

    updateShippingLegalNote();
    updateLineTotals(cart);

    document.querySelectorAll('.cart-link__bubble-num').forEach((node) => {
      node.textContent = cart.item_count;
    });
    document.querySelectorAll('.cart-link__bubble').forEach((node) => {
      node.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
    });
  };

  const syncCurrentCart = () => {
    const drawer = getDrawer();
    if (!drawer) return;

    fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then((response) => {
        if (!response.ok) throw new Error('cart sync failed');
        return response.json();
      })
      .then(updateSummary)
      .catch(() => {});
  };

  const scheduleInitialSync = () => {
    window.setTimeout(syncCurrentCart, 120);
    window.setTimeout(syncCurrentCart, 450);
  };

  const clearLoading = () => {
    const drawer = getDrawer();
    if (!drawer) return;
    drawer.querySelectorAll('.is-loading, .is-updating').forEach((node) => {
      node.classList.remove('is-loading');
      node.classList.remove('is-updating');
    });
  };

  const drawerAjaxUrl = () => {
    const base = window.theme && theme.routes && theme.routes.cartPage ? theme.routes.cartPage : '/cart';
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'view=ajax&t=' + Date.now();
  };

  const replaceProductsFromMarkup = (html, expectedItemCount) => {
    const drawer = getDrawer();
    if (!drawer) throw new Error('cart drawer missing');

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const items = doc.querySelector('.cart__items');
    const discounts = doc.querySelector('.cart__discounts');
    const productsTarget = drawer.querySelector('[data-products]');
    const discountsTarget = drawer.querySelector('[data-discounts]');

    if (!productsTarget) throw new Error('cart products target missing');
    if (Number(expectedItemCount) > 0 && !items) throw new Error('cart markup is stale');

    productsTarget.innerHTML = '';
    if (items) productsTarget.appendChild(items);

    if (discountsTarget) {
      discountsTarget.innerHTML = '';
      if (discounts) discountsTarget.appendChild(discounts);
    }
  };

  const fetchDrawerMarkup = () => {
    const useThemeMarkup = window.theme && theme.cart && typeof theme.cart.getCartProductMarkup === 'function';
    return useThemeMarkup
      ? theme.cart.getCartProductMarkup()
      : fetch(drawerAjaxUrl(), { credentials: 'same-origin', cache: 'no-store' }).then((response) => {
          if (!response.ok) throw new Error('drawer markup failed');
          return response.text();
        });
  };

  const rebuildProducts = (expectedItemCount) => {
    return fetchDrawerMarkup()
      .then((html) => replaceProductsFromMarkup(html, expectedItemCount))
      .catch(() => {
        return new Promise((resolve) => window.setTimeout(resolve, 120))
          .then(() => fetch(drawerAjaxUrl(), { credentials: 'same-origin', cache: 'no-store' }))
          .then((response) => {
            if (!response.ok) throw new Error('drawer markup retry failed');
            return response.text();
          })
          .then((html) => replaceProductsFromMarkup(html, expectedItemCount));
      });
  };

  const openDrawer = () => {
    const opener = document.querySelector('.js-drawer-open-cart, [aria-controls="CartDrawer"]');
    if (opener) {
      opener.click();
      return;
    }

    const drawer = getDrawer();
    if (!drawer) return;
    document.documentElement.classList.add('js-drawer-open');
    document.body.classList.add('js-drawer-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.dispatchEvent(new CustomEvent('drawerOpen.CartDrawer'));
  };

  const addCardToCart = (form, button) => {
    if (!form || form.dataset.lorenzosCartBusy === 'true') return;

    form.dataset.lorenzosCartBusy = 'true';
    const buttonWasDisabled = !!(button && button.disabled);

    if (button && button.classList) button.classList.add('is-loading');
    if (button) button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new FormData(form)
    })
      .then((response) => {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(() => fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' }))
      .then((response) => {
        if (!response.ok) throw new Error('cart fetch failed');
        return response.json();
      })
      .then((cart) => {
        return rebuildProducts(cart.item_count).then(() => {
          setDrawerEmptyState(cart);
          updateSummary(cart);
          openDrawer();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        });
      })
      .catch(() => {
        form.submit();
      })
      .finally(() => {
        delete form.dataset.lorenzosCartBusy;
        if (button && button.classList) button.classList.remove('is-loading');
        if (button) button.disabled = buttonWasDisabled;
        clearLoading();
      });
  };

  const changeItem = (key, quantity, row) => {
    if (!key || Number.isNaN(quantity) || quantity < 0) return;

    if (row && row.classList) row.classList.add('is-updating');

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity })
    })
      .then((response) => {
        if (!response.ok) throw new Error('cart change failed');
        return response.json();
      })
      .then((cart) => {
        updateSummary(cart);
        return rebuildProducts(cart.item_count).then(() => {
          updateSummary(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        });
      })
      .catch(() => {})
      .finally(clearLoading);
  };

  const keyFromRemoveLink = (link) => {
    if (!link) return '';
    const row = link.closest('.cart__item[data-key]');
    if (row) return row.getAttribute('data-key') || '';

    try {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      return url.searchParams.get('id') || '';
    } catch (error) {
      return '';
    }
  };

  const handleCartControl = (event) => {
    const drawer = getDrawer();
    if (!drawer || !drawer.contains(event.target)) return;

    const remove = event.target.closest('.cart__remove a, a[href*="/cart/change"][href*="quantity=0"], a[href*="/cart/change.js"][href*="quantity=0"]');
    const button = event.target.closest('.js-qty__adjust');
    if (!remove && !button) return;

    const now = Date.now();
    if (now - lastHandledCartControl < 650) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      return;
    }

    if (remove) {
      const key = keyFromRemoveLink(remove);
      const row = remove.closest('.cart__item[data-key]');
      if (!key) return;
      lastHandledCartControl = now;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      changeItem(key, 0, row);
      return;
    }

    const row = button.closest('.cart__item[data-key]');
    const input = row ? row.querySelector('.js-qty__num[data-id]') : null;
    if (!row || !input) return;

    const key = input.getAttribute('data-id') || row.getAttribute('data-key');
    const current = parseInt(input.value, 10) || 0;
    const next = button.classList.contains('js-qty__adjust--minus') ? Math.max(0, current - 1) : current + 1;

    lastHandledCartControl = now;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    input.value = next;
    changeItem(key, next, row);
  };

  if (!directControlsDisabled) {
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form || !form.matches || !form.matches(directAddSelector)) return;
      if (!form.getAttribute('action') || form.getAttribute('action').indexOf('/cart/add') === -1) return;

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      addCardToCart(form, event.submitter || form.querySelector('button[type="submit"]'));
    }, true);

    document.addEventListener('touchend', handleCartControl, { capture: true, passive: false });
    document.addEventListener('click', handleCartControl, true);
  }

  document.addEventListener('cart:updated', scheduleInitialSync);
  document.addEventListener('cart:build', scheduleInitialSync);
  document.addEventListener('drawerOpen.CartDrawer', scheduleInitialSync);
  document.addEventListener('page:loaded', scheduleInitialSync);
  document.addEventListener('DOMContentLoaded', scheduleInitialSync);
})();